// extracted by mini-css-extract-plugin
export default {"input":"LinkToMeeting_input__W8Az5"};